"use client"

import { useOutletContext, Navigate } from "react-router-dom"
import { useParams } from "react-router-dom"

const ProtectedRoute = ({ children, requireAuth = false }) => {
  const { companyName } = useParams()
  const { isCompanyAuth, isB2CAuth } = useOutletContext()
  const isAuthenticated = isCompanyAuth || isB2CAuth

  if (requireAuth && !isAuthenticated) {
    return <Navigate to={`/${companyName}/login`} replace />
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to={`/${companyName}`} replace />
  }

  return children
}

export default ProtectedRoute
